import { GDPR_COOKIE_NAME } from "@circle-react/components/constants";
import { useEffect } from "react";
import { useCookies } from "react-cookie";

import { setMetaPixelConsent } from "../../helpers/metaPixel";
import { consentStatus } from "./consentStatus";

export const useMetaPixel = (pixelId?: string, fbc?: string) => {
  const [cookies] = useCookies([GDPR_COOKIE_NAME]);
  const currentConsentStatus = consentStatus(cookies);

  useEffect(() => {
    setMetaPixelConsent(currentConsentStatus, pixelId, fbc);
  }, [currentConsentStatus, pixelId, fbc]);
};
